export default {
  'footer.fall-facilities': 'Alle Einrichtungen',
  'footer.about-avelios-medical': 'Über {tenant}',
  'footer.imprint': 'Impressum',
  'footer.privacy': 'Datenschutzerklärung',
  'footer.terms-of-usage': 'AGB',
  'footer.navigation': 'Navigation',
  'footer.credits': 'Externe Ressourcen',
  'footer.credits.external': 'Verlinkungen',
  'footer.facilities': 'Medizinische Einrichtungen',

  'credits.title': 'Externe Ressourcen',
  'select.language': 'Sprache auswählen',
  accessibility: 'Zugänglichkeit',
  'accessibility.description':
    'Hier haben Sie die Möglichkeit eine barrierefreie Ansicht des Patientenportals auszuwählen. Diese erleichtert die Nutzung durch eine verbesserte Lesbarkeit mit schwarzer Schrift, kontrastreichen Farben und einer klaren Kennzeichnung relevanter Funktionen.',
  'accessibility.status': 'Zugänglichkeit: {setting}',
  'accessibility.active': 'aktiv',
  'accessibility.inactive': 'deaktiviert',
  'accessibility.tooltip':
    'Die Aktivierung dieser Einstellung verändert die Darstellung einiger Inhalte auf der Seite um bessere Zugänglichkeit zu erzielen.',

  'credits.text':
    'Um die eigenen Dienste auch grafisch bestmöglich für die Nutzer zu gestalten, bindet {tenant} in Teilen des Patientenportals Grafiken von externen Anbietern ein. Nachfolgend finden Sie entsprechende Verweise zu den jeweiligen Grafiken, um das Urheberrecht zu respektieren und den Erstellern der Grafiken Kredit zu zollen.',
};
